import * as fromBlog from '../reducers/blogReducers'

export const getBlog = (state) => fromBlog.getBlog(state.blog)
export const getBlogList = (state) => fromBlog.getBlogList(state.blog)
export const getBlogData = (state) => fromBlog.getBlogData(state.blog)
export const getBlogMedias = (state) => fromBlog.getBlogMedias(state.blog)
